import { createAction, createAsyncAction } from 'typesafe-actions';
import { Modes } from 'components/Modal';
import { NotificationModes } from 'components/Modal/enums';

export type ModalOpenPayload = {
  animated?: boolean;
  data?: unknown;
  id: string | number;
  mode?: Modes;
  notificationMode?: NotificationModes;
};
export const modalOpen = createAction('modal/open')<ModalOpenPayload>();

export type ModalClosePayload = {
  animated?: boolean;
  callBack?: () => void;
  id: string | number;
};
export const modalClose = createAsyncAction(
  'modal/close/request',
  'modal/close/success',
  'modal/close/failure',
)<ModalClosePayload, ModalClosePayload, ModalClosePayload>();

export type SetClosingClassPayload = {
  id: string | number;
};
export const setClosingClass = createAction(
  'modal/setClosingClass',
)<SetClosingClassPayload>();

export type ResetClosingClassPayload = {
  id: string | number;
};
export const resetClosingClass = createAction(
  'modal/resetClosingClass',
)<ResetClosingClassPayload>();

export const reset = createAction('modal/reset')();
